import React from 'react';
import FileUrlFieldEditor from './FileUrlFieldEditor';

const ImageUrlFieldEditor = (props) => {
  return <FileUrlFieldEditor {...props} type='image' />;
};

export default ImageUrlFieldEditor;
